import * as React from 'react';
import { useDispatch } from 'react-redux';

import { retrySendMessageById } from '../../../../../actions/sendMessage/retrySendMessageById';
import { setViewOffer } from '../../../../../thunks/chatbot/feedback/setViewOffer';
import { getOfferShareUrl } from '../utils/getOfferShareUrl';
import { trackClickRecommendation } from '../tracking';
import { IOfferMessage } from '../types';
import { useMessageText } from '../../../hooks';
import { useRuntimeSetting } from '../../../../../hooks/useRuntimeSetting';
import { useMessageContext } from '../../../../../utils/messageContext';

export const useOfferMessageActions = (offer: IOfferMessage | undefined) => {
  const { messageId, message, messageType, chatId } = useMessageContext();
  const { communicationId } = message;
  const dispatch = useDispatch();

  const isHorizontalGalleryOffersViewEnabled = useRuntimeSetting<boolean>(
    'frontend-chats.horizontalGalleryOffers.Enabled',
    false,
  );
  const formattedText = useMessageText({ message, messageId, messageType, chatId });

  const shareUrl = React.useMemo(() => (offer ? getOfferShareUrl(offer, true) : ''), [offer]);

  const handleReload = React.useCallback(() => {
    if (offer) {
      dispatch(retrySendMessageById(chatId, messageId));
    }
  }, [offer, dispatch, chatId, messageId]);

  const onClick = React.useCallback(() => {
    if (!offer) {
      return;
    }

    dispatch(setViewOffer(offer.realtyOfferId));
    trackClickRecommendation(
      offer.realtyOfferId,
      communicationId,
      offer.isExpertEnabled ?? false,
      isHorizontalGalleryOffersViewEnabled,
      offer.position ?? undefined,
    );
  }, [offer, dispatch, communicationId, isHorizontalGalleryOffersViewEnabled]);

  return {
    shareUrl,
    formattedText,
    isHorizontalGalleryOffersViewEnabled,
    handleReload,
    onClick,
  };
};
